// Bahagi ng delivery-picker module set (dating monolitikong
// cart-delivery-picker.js, hinati by-responsibility 2026-08-24 — PURE
// REFACTOR, walang behavior change). Shared namespace:
// window.FlowercartDeliveryPicker (DP); mauna ang delivery-picker-state-config.js
// sa load order, at ang file na ITO ang panghuli — siya ang nagre-rehistro
// ng DOMContentLoaded entry point.
//
// Saklaw ng file na ito: ang mount() orchestrator lang — pinagdudugtong ang
// lahat ng module.
(function () {
  const DP = (window.FlowercartDeliveryPicker = window.FlowercartDeliveryPicker || {});
  const state = DP.state;

  function mount() {
    if (!DP.setupDayjs() || typeof flatpickr === "undefined") {
      setTimeout(mount, 100);
      return;
    }

    if (!DP.cacheElements()) return;

    DP.initFlatpickr();

    const scheduleChanged = DP.sanitizeSelectedSchedule();
    DP.preselectDefaultDate();

    DP.bindCheckoutValidation();
    DP.bindStaleScheduleResync();
    DP.bindCardMessageAutosave();

    DP.renderDateStrip();
    DP.renderTimeSlots(state.elements.dateInput.value || null, true);
    DP.renderCountdown();
    if (!state.countdownIntervalId) {
      // Sabay-sabay dapat mag-tick ang countdown at ang time-slot grid —
      // kung hindi, may cut-off na slot na naiiwang muted-looking pero
      // clickable ang tunay na state hanggang sa susunod na date-change o
      // checkout-click resync (2026-09-01, na-verify: 12PM-3PM naka-tick
      // pero clickable pa 1+ oras pagkalampas ng cutoff niya).
      state.countdownIntervalId = window.setInterval(() => {
        // Hakbang 3 (2026-09-02): kapag luma na ang window (day rollover o
        // lumagpas na ang cutoff nang hindi pa na-advance ang minDate),
        // mag-refetch — magre-render ulit ang refreshScheduleRules() mismo.
        // Kung hindi stale, sapat na ang parehong window para sa cosmetic
        // re-render na ito (Cut-off badges, countdown) — Date.now() ang
        // laging pinagbabatayan ng lastOrderAt comparison.
        if (DP.isScheduleStale()) {
          void DP.refreshScheduleRules();
          return;
        }
        DP.renderCountdown();
        DP.renderTimeSlots(state.elements.dateInput.value || null, true);
      }, 60000);
    }

    if (scheduleChanged) {
      void DP.updateCart(DP.buildCartPayload(), "mount");
    }

    DP.syncSelectorDisplays();
    void DP.refreshScheduleRules();
  }

  DP.mount = mount;

  document.addEventListener("DOMContentLoaded", mount);
})();
